import { defineStore } from 'pinia'


type IOHeroDividerShape = number


export interface IOStoreState {
  version: string
  initialised: boolean

  // IO HEADER
  headerFixed: boolean
  headerFixedMini: boolean

  // Mobile Navigation
  mobileMenuActive: boolean //  the mobile snap point has been activated and the moible headeer isi visiebl
  mobileNavFlyoutActive: boolean

  // IO MEGA MENU
  megaWidth: string
  megaHeight: string
  megaMaxWidth: string
  megaMinWidth: string
  megaMaxHeight: string
  megaMinHeight: string
 
  megaCaretWidth: string
  megaCaretHeight: string
  megaCaretLeft: string

  megaPopoverOffsetLeft: string

  // Hero
  hero: {
    key: string,

    base: {
      height?: string,
      minHeight?: string,
      maxHeight?: string,
    },

    media: {
      type: 'image' | 'video',
      transition?: {
        mode?: 'out-in' | 'duo'
      },
      media: {
        // image
        src?: string,
        alt?: string,

        // video
        vid?: string,
        image?: string,
        // alt?: string,
      }
    }

    content?: {
      model: ContentModel,
      transition?: {
        mode?: 'out-in' | 'duo'
      },
      content: {
        title?: string,
        description?: string,
        hairline?: string,
        line?: boolean,
        lineColor?: string,
        tags?: Array<string>,
      }
    },

    shapes?: {
      transition?: {
        mode?: 'out-in' | 'duo'
      },
      shapes: Array<{
        id: string,
      }>
    },

    overlays: {
      transition?: {
        mode?: 'out-in' | 'duo'
      },
      overlays: Array<{
        type: 'gradient' | 'texture',
        options: Record<string, any>,
      }>
    },

    divider: {
      transition?: {
        mode?: 'out-in' | 'duo'
      },
      divider: {
        shape?: IOHeroDividerShape,
        styles?: Record<string, any>,
        options?: Record<string, any>,
      }
    }
  }

 
}

export const useIOStore = defineStore('IOStore', {
  state: (): IOStoreState => ({
    version: '1.0.9',
    initialised: false,

    // IO HEADER
    headerFixed: false,
    headerFixedMini: false, // this is disabled at the moment

    // Mobile Navigation  
    mobileMenuActive: false,
    mobileNavFlyoutActive: false,

    // IO MEGA MENU
    megaWidth: '80vw',
    megaMinWidth: '100px',
    megaMaxWidth: '80vw',

    megaHeight: 'calc-size(auto)',
    megaMinHeight: '100px',
    megaMaxHeight: '80vh',

    megaCaretWidth: '100px',
    megaCaretHeight: '100px',
    megaCaretLeft: '100px',

    megaPopoverOffsetLeft: '100px',


    // io Hero
    hero: {
      key: 'default',

      base: {
        height: '',
        minHeight: '',
        maxHeight: '',
      },

      media: {
        type: 'image',
        transition: {
          mode: 'out-in'
        },
        media: {
          src: '/droplets-splash-1.jpg',
          alt: 'iSolvents',
        }
      },

      content: {
        model: 'page',
        transition: {
          mode: 'out-in'
        },
        content: {
          hairline: 'Crafting a Cleaner, Greener Future.',
          title: 'Crafting a Cleaner, Greener Future.',
          description: 'We are a global leader in the production and distribution of renewable energy solutions, including ethanol and essential chemicals. Our mission is to create a sustainable future by providing clean, renewable energy alternatives to traditional fossil fuels.',
          tags: [],
          line: true,
          lineColor: 'white',
        }
      },

      shapes: {
        transition: {
          mode: 'out-in'
        },
        shapes: [{
          id: 'content-panel',
        }]
      },

      overlays: {
        transition: {
          mode: 'out-in'
        },
        overlays: [{
          type: 'gradient',
          options: {
            direction: 'to bottom',
            colors: ['#000', '#000'],
            opacity: 0,
          }
        }]
      },

      divider: {
        transition: {
          mode: 'out-in'
        },
        divider: {
          shape: 1,
          styles: {},
          options: {},
        }
      }
    },


    
  }),

  actions: {
    updateInitialised(initValue: boolean) {
      this.initialised = initValue
    },

    // Testing

    assignHeroContent(model: ContentModel, content: any) {

      console.log("assignHeroContent", model, content)
      this.hero.content!.model = model
      if(this.hero.content) {
        this.hero.content!.content = Object.assign({}, this.hero.content!.content, content)
      } else {
        this.hero.content = {
          model: model,
          content: content,
          transition: {
            mode: 'out-in'
          }
        }
      }
    },

    assignHeroMedia(type: 'image' | 'video', media: any) { 
      this.hero.media.type = type
      this.hero.media.media = Object.assign({}, this.hero.media.media, media)
    },

    assignHeroOverlays(overlays: Array<{
      type: 'gradient' | 'texture',
      options: Record<string, any>,
    }>) {
      if(Array.isArray(overlays)) {
        this.hero.overlays.overlays = overlays
      } else {
        this.hero.overlays.overlays = []
      }
    },
    
  },

  getters: {
    getInitialised: state => state.initialised,
    heroBaseObject: state => state.hero?.base ?? {},
    heroMediaObject: state => state.hero?.media ?? {
      media: {
        type: 'image',
        src: 'https://picsum.photos/200/300',
        alt: 'Hero Image',
      }
    },
    heroContentObject: state => state.hero?.content ?? {
      content : {
        title: 'Default Title',
        description: 'Default Description'
      }
    },

    heroShapesObject: state => state.hero?.shapes ?? [],
    heroOverlaysObject: state => state.hero?.overlays ?? [],
    heroDividerObject: state => state.hero?.divider ?? {
      divider: {
        type: 'gradient',
        styles: {},
        options: {},
      }
    },
  },
})
